// extracted by mini-css-extract-plugin
module.exports = {"content":"PrivacyPolicy_content__1Gdic"};